import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
} from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../configurations/configurations.config";
import { handleFlgStatus } from "../../../components/facilities/AccountFacility";
import SortableColumn from "../../../components/SorterTableColumn";

const { Text, Title } = Typography;

const ManageHolidays = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [holidaysList, setHolidaysList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [officesData, setOfficesData] = useState([]);
  const [officeId, setOfficeId] = useState(0);
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (_, __, sorter) => {
    setSortedInfo(sorter || {});
  };

  const columns = [
    {
      title: "Holiday Name",
      dataIndex: "name",
    },
    SortableColumn({
      label: "Start Date",
      dataIndex: "startDate",
      dataType: "date",
      sorter: (a, b) => a.startDate.localeCompare(b.startDate),
    }),
    // SortableColumn({
    //   label: "Start Date",
    //   dataIndex: "startDate",
    //   dataType: "date",
    //   sorter: (a, b) => a.startDate.localeCompare(b.startDate),
    //   sortedInfo,
    //   columnKey: "startDate",
    // }),
    {
      title: "End Date",
      dataIndex: "endDate",
    },
    {
      title: "Repayments Scheduled To",
      dataIndex: "repaymentsRescheduledTo",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  useEffect(() => {
    getHolidaysList();
    getOffices();
    BOM.HasPermission("CREATE_HOLIDAY") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getHolidaysList = () => {
    const params = {
      orderBy: "fromDate",
      sortOrder: "DESC",
    };
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.Holidays, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempHolidaysList = [];

        objList.forEach((element) => {
          tempHolidaysList.push({
            key: element?.id,
            id: element?.id,
            name: element?.displayName ? element?.displayName : "-",
            startDate: element?.isLoanOfficer ? "Yes" : "No",
            endDate: element?.officeName ? element?.officeName : "-",
            repayments: element?.officeName ? element?.officeName : "-",
            status: element?.isActive ? (
              <Tag icon={<CheckCircleOutlined />} color={"success"}>
                Active
              </Tag>
            ) : (
              <Tag icon={<CheckCircleOutlined />} color={"red"}>
                Inactive
              </Tag>
            ),
          });
        });

        setHolidaysList(tempHolidaysList);
        setOriginalList(tempHolidaysList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        officeId,
        sortOrder: "DESC",
        orderBy: "fromDate",
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Holidays, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempHolidaysList = [];

          objList.forEach((element) => {
            tempHolidaysList.push({
              key: element?.id,
              id: element?.id,
              name: element?.name ? element?.name : "-",
              startDate: BOM.DateTime(element?.fromDate, "only-date"),
              endDate: BOM.DateTime(element?.toDate, "only-date"),
              repaymentsRescheduledTo: element?.repaymentsRescheduledTo
                ? BOM.DateTime(element?.repaymentsRescheduledTo, "only-date")
                : "Next Repayment Date",
              status: handleFlgStatus(element?.status?.value, {}, true),
            });
          });

          resolve(tempHolidaysList);
        }
      });
    });
  };

  const getOffices = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Offices, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempOfficesArray = [];

        objList.forEach((element) => {
          tempOfficesArray.push({
            value: element?.id,
            label: element?.name,
          });
        });

        const defaultOffice = tempOfficesArray.find(
          (option) => option.label.toLowerCase() === "head office"
        );
        if (defaultOffice) {
          form.setFieldsValue({ office: defaultOffice.value });
          handleOfficeChange(defaultOffice.value);
        }

        setOfficesData(tempOfficesArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      //   BOM.HasPermission("READ_STAFF") &&
      cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_HOLIDAY") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({ type: item });
    });
  };
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setHolidaysList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.name?.toLowerCase().includes(searchKey?.toLowerCase())
    );
    setHolidaysList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-holiday", {
        state: { id: selectedRow.id, officeId: officeId },
      });
    } else {
      console.log("Could not open the link");
    }
  }
  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-holiday", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }
  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-holiday", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOfficeChange(idParam) {
    setOfficeId(idParam);
    const params = {
      officeId: idParam,
      orderBy: "fromDate",
      sortOrder: "DESC",
    };
    const url = `${apiConfig.Holidays}`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.filter((item) => item?.status.value !== "Deleted");
        let tempHolidaysList = [];

        objList.forEach((element) => {
          tempHolidaysList.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            startDate: BOM.DateTime(element?.fromDate, "only-date"),
            endDate: BOM.DateTime(element?.toDate, "only-date"),
            repaymentsRescheduledTo: element?.repaymentsRescheduledTo
              ? BOM.DateTime(element?.repaymentsRescheduledTo, "only-date")
              : "Next Repayment Date",
            status: handleFlgStatus(element?.status?.value, {}, true),
          });
        });

        setHolidaysList(tempHolidaysList);
        setOriginalList(tempHolidaysList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.manageHolidays}
        pageItems={staticConfig.manageHolidaysBreadcrumbItems}
      />

      <Card
        title={`${labelConfig.holidays} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>

            <Form form={form}>
              <Form.Item name="office">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.branch,
                    "select"
                  )}
                  options={officesData}
                  onChange={handleOfficeChange}
                  showSearch
                />
              </Form.Item>
            </Form>

            <DownloadTableButtons
              downloadData={holidaysList}
              columns={columns}
              fileName={"Holidays List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            onChange={handleChange}
            columns={columns}
            dataSource={holidaysList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageHolidays);
